<template>
	<div class="container2">
		<div class="main">
			<div class="main-img">
				<img src="../../assets/img/cable/111.jpeg" />
			</div>
			<div class="menu">
				<div class="menu-left">
					<div class="menu-left1">
						<span class="menu-left1-color">能量工厂</span>
						<span>共享充电线</span>
						<span class="menu-left1-color">-二维码付费共享充电器</span>
					</div>
					<div class="menu-left2">
						<span>能量工厂充电线是能量工厂研发的用于酒店、会所、网咖等封闭式场所用的共享充电线，支持TYPE-C，苹果Lightning和安卓手机充电，
							3U口输出满足市面上99%的智能手机充电需求，扫码即用简单方面支持免押金扫码租借。</span>
					</div>
					<div class="menu-left3">代理商可以根据服务场所的不同，自定义设置收费模式，利润秒结算，随时提现，回本时间在2个月左右，一次投放可以持续赚钱盈利。</div>
				</div>
				<div class="menu-right">
					<img src="../../assets/img/cable/2.jpeg" />
				</div>
			</div>
			<div class="menu">
				<div class="menu-main1">
					<!-- <el-video :src="videoUrl" poster="../../assets/logo.png" controls></el-video> -->
					<img src="../../assets/img/cable/nlgc2.jpg" />
				</div>
				<div class="menu-main2">
					<div class="menu-main2-1">能量工厂共享充电线</div>
					<div class="menu-main2-2">品牌名称：能量工厂科技</div>
					<div class="menu-main2-2">长度：150CM</div>
					<div class="menu-main2-2">颜色：乳白色/灰色</div>
					<div class="menu-main2-2">租借设置：能量工厂代理商通过代理商后台APP设置</div>
					<div class="menu-main2-2">是否免押金：支付宝微信扫码免押金租借</div>
					<div class="menu-main2-2">价格设定：可设定3小时，5小时，12小时套餐费用</div>
					<div class="menu-main2-2">产品质保：半年内有质量问题以换代修</div>
					<div class="menu-main2-2">收益结算方式：收益秒结算，提现秒到账</div>
				</div>
			</div>
			<div class="menu">
				<div class="passmain1">
					<img src="../../assets/img/cable/8.jpg" />
				</div>
				<div class="passmain2">
					<div class="passmain2-1">能量工厂酒店密码式共享充电线</div>
					<div class="passmain2-2">
						<div class="passmain2-2-text1">能量工厂共享充电线-工厂直销高品质二维码付费共享充电器</div>
						<div class="passmain2-2-text2">电源插头:AC100-240V宽电压输入，突破地域性的电压限制，能量工厂共享充电线支持10W高速快充，外壳采用ABS高温阻燃材料制成，
							内置高精度硬件限流芯片，有效预防过压、过流、过温、短路等多重安全保护，耐静电，防低电磁干扰。</div>

					</div>
					<div class="passmain2-2">
						<div class="passmain2-2-text1">方便简单</div>
						<div class="passmain2-2-text2">扫码充电扫码归还密码器:内置通信模块，智能控制电源输出，扫二维码付费，按键输入密码，插上手机开始计费，
							充电器价格代理商后台自由设定。</div>
					</div>
					<div class="passmain2-2">
						<div class="passmain2-2-text1">三合一数据线</div>
						<div class="passmain2-2-text2">
							手机接口:可同时使用与苹果和安卓手机和 Type-c接口，每个接口之间都采用了独立的限流识别IC，确保每个接口之间互不干扰，不会存在电流倒流的问题，
							同时外部发生短路的情況芯片会切断输出，当外部短路移除时，
							电源恢复输出，同时能智能识别手机，并与手机进行数据匹配，充电更快，而且能更好的保护手机，苹果安卓手机平板都能兼容，每个接口输出能达到2A，
							兼容市面上大多数5V电子产品，支持多个用电设备同时使用。
						</div>
					</div>
					<div class="passmain2-2">
						<div class="passmain2-2-text1">拆开自毁保护</div>
						<div class="passmain2-2-text2">能量工厂共享充电线采取专利设计，拆开自毁防暴力拆解，采取电路流量卡内置模式，只有软硬件结合才能充电，保护代理商利益。</div>
					</div>
				</div>
			</div>
			<div class="advantage">
				<div class="menu3">
					<div class="menu3-top">
						<div class="menu3-top1">能量工厂共享充电线产品优势介绍</div>
						<div class="menu3-top2">代理商后台独立设置，通过能量工厂可以看到名下共享充电线的使用情况</div>
					</div>
				</div>
				<div class="advantage1">
					<div class="advantage1-all">
						<div class="advantage1-all-img">
							<img
								src="//16856361.s21i.faiusr.com/4/ABUIABAEGAAg6eLT5gUoh6K3QTCwCTiwCQ!200x200.png.webp" />
						</div>
						<div class="advantage1-all-text">
							<div class="advantage1-all-text1">0成本高回报</div>
							<div class="advantage1-all-text2">
								设备完全免费寄、换、退、补，全程设备成本、运费均由我司承担，同时给酒店80%真实分成，百分百可靠。
							</div>
						</div>
					</div>
					<div class="advantage1-all">
						<div class="advantage1-all-img">
							<img
								src="//16856361.s21i.faiusr.com/4/ABUIABAEGAAgj_PT5gUorNfAxgUwsAk4sAk!200x200.png.webp" />
						</div>
						<div class="advantage1-all-text">
							<div class="advantage1-all-text1">独立后台</div>
							<div class="advantage1-all-text2">
								合作商户拥有完全独立后台，收益秒到账，提现秒到，单笔提现仅收取5元/笔通道费用。
							</div>
						</div>
					</div>
					<div class="advantage1-all">
						<div class="advantage1-all-img">
							<img
								src="//16856361.s21i.faiusr.com/4/ABUIABAEGAAgwePT5gUouN7UNDCwCTiwCQ!200x200.png.webp" />
						</div>
						<div class="advantage1-all-text">
							<div class="advantage1-all-text1">投放补贴</div>
							<div class="advantage1-all-text2">
								成功合作以后，我司将补贴一定金额的红包给到客房阿姨，减轻酒店需要安排人员投放的成本。
							</div>
						</div>
					</div>
					<div class="advantage1-all">
						<div class="advantage1-all-img">
							<img
								src="//16856361.s21i.faiusr.com/4/ABUIABAEGAAg1_PT5gUo3KKlbTCwCTiwCQ!200x200.png.webp" />
						</div>
						<div class="advantage1-all-text">
							<div class="advantage1-all-text1">OTA代运营</div>
							<div class="advantage1-all-text2">
								一家好的代运营公司可以帮助酒店快速提升收入增长，我司提供免费的OTA代运营，佣金为市场最低，只为了酒店收入增长的保驾护航
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="scene">
				<div class="scene1">能量工厂共享充电线场景展示</div>
				<div class="scene2">
					<el-carousel :interval="5000"  arrow="hover">
						<el-carousel-item v-for="(item,index) in imglist" :key="index">
							<img class="scene2-img" :src="item.img" mode=""/>
							<!-- <el-image
								:src="item.img"></el-image> -->
						</el-carousel-item>
					</el-carousel>
				</div>
			</div>
			<div class="fotter">
				<div class="fotter1">
					<div class="fotter1-text">
						<span class="color-text3">能量工厂</span>
						<span>官网-深圳市乐园互联网科技有限公司</span>
					</div>
					<div class="fotter1-text2">
						<div class="fotter1-text2-1">
							<span>能量工厂-全球十大</span>
							<span class="color-text">共享充电线</span>
							<span>品牌之一，</span>
							<span class="color-text2">能量工厂3c认证</span>
						</div>
						<div class="fotter1-text2-2">
							<span class="fotter1-text2-2-left color-text3">共享充电线</span>
							<span>，共享充电宝加盟代理，</span>
							<span class="fotter1-text2-2-left color-text3">共享WiFi贴</span>
							<span>，酒店售货机厂家招商加盟</span>
						</div>
						<div class="fotter1-text2-3">
							<span>代理加盟咨询招商总监：王总 </span>
							<span class="color-text3">18664573264</span>
							<span> 微信同号</span>
						</div>
						<div class="fotter1-text2-4">
							<span>公司总部：广东省深圳市宝安区新桥街道上星社区上星路万科星城星宸大厦第3栋6楼整层</span>
						</div>
					</div>
				</div>
				<div class="fotter2">
					<el-image src="../../assets/img/erweim1.png"></el-image>
				</div>
			</div>
			
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				videoUrl:'',
				imglist:[
					{
						id:1,
						img:require('../../assets/img/cable/10.jpg')
					},
					{
						id:2,
						img:require('../../assets/img/cable/11.jpg')
					},
					{
						id:3,
						img:require('../../assets/img/cable/12.jpg')
					},
				]
			}
		},
		methods: {

		}
	}
</script>

<style scoped>
	.container2 {
		background: #ffffff;
		padding-bottom: 20px;
	}

	.main-img {
		width: 100%;
		height: 400px;
	}

	.main-img img {
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	.menu {
		display: flex;
		padding: 50px 50px;
		/* justify-content: center; */
	}

	.menu-left {
		width: 50%;
		text-align: left;
	}

	.menu-left1 {
		font-size: 24px;
		font-weight: bold;
	}

	.menu-left2 {
		margin-top: 20px;
		line-height: 40px;
		font-size: 16px;
		color: rgb(153, 153, 153);
		font-family: 微软雅黑;
		text-align: left;
	}

	.menu-left3 {
		margin-top: 40px;
		font-size: 16px;
		color: rgb(153, 153, 153);
		font-family: 微软雅黑;
		text-align: left;
	}

	.menu-right {
		width: 50%;
		margin-left: 5%;
	}

	.menu-right img {
		width: 55%;
		/* height: 300px; */
	}

	.menu-left1-color {
		color: #2ba0e8;
	}

	.menu-main1 {
		width: 50%;
	}
	.menu-main1 img{
		width: 47%;
		height: 74%;
	}

	.menu-main2 {
		width: 50%;
	}

	.menu-main2-1 {
		text-align: center;
		color: rgb(30, 80, 174);
		font-size: 20px;
		line-height: 36px;
	}

	.menu-main2-2 {
		text-align: left;
		line-height: 36px;
		font-size: 16px;
		color: rgb(153, 153, 153);
	}

	.passmain1 {
		width: 50%;

	}

	.passmain1 img {
		width: 75%;
	}

	.passmain2 {
		width: 50%;
		clear: both;
		outline: 0;
		position: relative;
		white-space: pre-wrap;
		word-break: normal;
		text-align: left;
	}

	.passmain2-1 {
		font-size: 24px;
		color: rgb(31, 135, 232);
	}

	.passmain2-2 {
		margin-top: 30px;
	}

	.passmain2-2-text1 {
		font-size: 16px;
		font-family: "Microsoft YaHei", 微软雅黑;
		font-weight: bold;
	}

	.passmain2-2-text2 {
		font-size: 16px;
		white-space: normal;
	}

	.advantage {
		margin-top: 30px;
	}

	.menu3-top1 {
		font-size: 24px;
		color: rgb(30, 80, 174);
		text-align: center;
		line-height: 46px;
	}

	.menu3-top2 {
		color: rgb(51, 51, 51);
		text-align: center;
		font-size: 16px;
	}

	.advantage1 {
		/* display: flex;
		align-items: center;
		justify-content: center; */
		display: flex;
		/* flex-wrap: nowrap; */
		position: relative;
		margin-top: 20px;
		margin-left: 5%;
		margin-right: 5%;
		padding-top: 20px;
		background: linear-gradient(0deg, #d5efff 0%, #ffffff 100%);
		border: 1px solid #f5f5f5;
		flex-wrap: wrap;
	}
	.advantage1-all{
		width: 25%;
		/* flex: 1; */
		max-width: 100%;
	}

	.advantage1-all-img img {
		width: 87px;
		height: 87px;
	}

	.advantage1-all-text1 {
		font-size: 20px;
		text-align: center;
	}

	.advantage1-all-text {
		width: 61%;
		line-height: 30px;
		margin: 15px auto;
	}

	.advantage1-all-text2 {
		font-size: 14px;
		color: rgb(153, 153, 153);
	}

	.scene {
		margin-top: 30px;
		text-align: center;
	}

	.scene1 {
		font-size: 24px;
	}

	.scene2 {
		width: 50%;
		margin: 20px auto;
	}
	
	.fotter{
		padding-top: 3%;
		padding-left: 12%;
		padding-right: 12%;
		display: flex;
		background-color: #ffffff;
	}
	.fotter1{
		width: 50%;
		text-align: left;
		line-height: 30px;
	}
	.fotter2{
		width: 50%;
	}
	.fotter1-text{
		font-size: 26px;
		color: rgb(51, 51, 51);
	}
	.fotter1-text2{
		margin-top: 3%;
	}
	.fotter1-text2-4{
		margin-top: 3%;
	}
	

	/* ::v-deep .el-carousel__arrow--left {
		top: 50%;
		left: 0;
		font-size: 25px;
		color: #ffffff;
		height: 100%;
		border-radius: 0px !important;
		background: rgba(0, 0, 0, .3);
		box-sizing: border-box;
		cursor: pointer;
		height: 100%;
		overflow: hidden;
		position: absolute;
		width: 7.5%;
	}

	::v-deep .el-carousel__arrow--right {
		top: 50%;
		right: 0;
		font-size: 15px;
		color: #ffffff;
		width: 50px;
		height: 100%;
		border-radius: 0px !important;
		background: rgba(0, 0, 0, .3);
		box-sizing: border-box;
		cursor: pointer;
		height: 100%;
		overflow: hidden;
		position: absolute;
		width: 7.5%;
	} */
	
	.color-text {
		color: rgb(30, 80, 174);
	}
	.color-text2 {
		color: rgb(230, 74, 25);
	}
	.color-text3{
		color: rgb(73, 110, 232);
	}
	.scene2-img{
		width: 100%;
		height: 100%;
		object-fit: contain;
	}
</style>